import {TrainingsCardSection} from './TrainingsCardSection';
export default TrainingsCardSection;
